import axios from 'axios';
import {
  initPortalEmbedBridge,
  isPortalEmbedded,
  isWorkflowUrl,
  portalBridgeFetch,
} from './portalEmbedApi';

initPortalEmbedBridge();

const axiosInstance = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Basic UE9SVEFMOldsQ2VuemVAUG9ydGFsMjAyNg==',
  },
});

function isNetworkError(error) {
  return (
    !error?.response ||
    error?.code === 'ERR_NETWORK' ||
    String(error?.message || '').includes('Network Error')
  );
}

async function bridgeAxiosRequest(config) {
  const method = (config.method || 'get').toUpperCase();
  const url = axios.getUri(config);
  const headers = { ...(config.headers || {}) };
  const body =
    config.data != null
      ? typeof config.data === 'string'
        ? config.data
        : JSON.stringify(config.data)
      : undefined;

  const response = await portalBridgeFetch(url, { method, headers, body });
  const data = await response.json();
  return {
    data,
    status: response.status,
    statusText: '',
    headers: response.headers,
    config,
  };
}

axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.url && isPortalEmbedded() && isWorkflowUrl(config.url)) {
      config.adapter = async (cfg) => bridgeAxiosRequest(cfg);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    if (
      config &&
      !config.__portalBridgeRetried &&
      isPortalEmbedded() &&
      isWorkflowUrl(config.url || '') &&
      isNetworkError(error)
    ) {
      config.__portalBridgeRetried = true;
      return bridgeAxiosRequest(config);
    }

    if (error.code === 'ERR_CERT_AUTHORITY_INVALID' ||
        error.code === 'ERR_CERT_COMMON_NAME_INVALID' ||
        error.code === 'ERR_CERT_DATE_INVALID' ||
        error.message?.includes('CERT') ||
        error.message?.includes('certificate')) {
      return Promise.reject({
        ...error,
        isSSLError: true,
        message: `Erro de certificado SSL (${error.code || 'CERT'}). Clique em "Abrir URL" para resolver rapidamente.`,
        originalError: error
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
